export default __webpack_public_path__ + "static/media/m3.7a808011.png";